import { render, staticRenderFns } from "./dates.vue?vue&type=template&id=81ef1bc0&scoped=true&"
import script from "./dates.vue?vue&type=script&lang=js&"
export * from "./dates.vue?vue&type=script&lang=js&"
import style0 from "./dates.vue?vue&type=style&index=0&id=81ef1bc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ef1bc0",
  null
  
)

export default component.exports